<template>
  <section class="page-section page---welcome ">
    <div class="container-fluid">
      <div class="row align-items-start justify-content-between">
        <Controls></Controls>
        <Bidder></Bidder>
      </div>
    </div>
  </section>
</template>
<script>
import Bidder from "./auctioneer/Bidder";
import Controls from "./auctioneer/Controls";

export default {
  components: {
    Controls,
    Bidder,
  },
  data() {
    return {
      item: {},
    };
  },
}
</script>
